import ReservationsCard from './ReservationsCard'
export default ReservationsCard
